import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';

function NameCard() {
  return(
    <div className="container">
      <img src='/dhanvin.jpeg' id='logo' alt='Logo' />
      <div>
        <h1 id='name'>Dhanvin K</h1>
        <p id="info">I'm an aspiring <span id='diff'>Python</span>, <span id='diff'>HTML</span>, <span id='diff'>CSS</span>, <span id='diff'>Javascript</span> developer and currently learning<span id='diff'> React</span>.<br/>Find me on <a id='diff-2' href='https://github.com/quantum-strike'>Github</a>.</p>
      </div> 
    </div>
  )
}

function ProductCard({ name, arc, dis, link }) {
  return (
    <div>
        <img src={arc} className="card-img-top" alt="..."></img>
        <h5 className="card-title">{name}</h5>
        <p className="card-text">{dis}</p>
        <a href={link} className="btn btn-primary">Take a Look</a>
    </div>

  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const page = (
  <div>
    <NameCard />
    <br />
    <div id="menu">
      <div className="row">
          <div className="col-sm-6 mb-3 mb-sm-0">
            <div className="card">
              <div className="card-body">
                <ProductCard name='dhan-weather' arc='/weather.png' dis='get weather for almost any location in the world!' link='https://dhan-weather.netlify.app'/>
              </div>
            </div>
            <br />
            <div className="card">
              <div className="card-body">
                <ProductCard name='dhanTune' arc='/music.png' dis='listen to music, without ads!' link='https://dhantune.pythonanywhere.com'/>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <ProductCard name='dhan-tools' arc='/tools.png' dis='a simple, but useful timer and stopwatch app.' link='https://dhan-tools.netlify.app'/>
              </div>
            </div>
            <br />
            <div className="card">
              <div className="card-body">
                <ProductCard name='dhanBolt' arc='/bolt.png' dis='a Lightweight client for dhanTune with gesture controls' link='https://dhanBolt.netlify.app'/>
              </div>
            </div>
          </div>
        </div>
      </div>

  <br />
  <br />
  <br />
  <br />

  </div>

)

root.render(page);
